import { Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import AppLayout from '@/components/layout/AppLayout'
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import KegiatanDetailPage from '@/pages/kegiatan/KegiatanDetailPage'
import KegiatanFormPage from '@/pages/kegiatan/KegiatanFormPage'
import PesertaFormPage from '@/pages/kegiatan/PesertaFormPage'
import PresensiPage from '@/pages/presensi/PresensiPage'
import PesertaDetailPage from '@/pages/presensi/PesertaDetailPage'
import LaporanListPage from '@/pages/laporan/LaporanListPage'
import LaporanFormPage from '@/pages/laporan/LaporanFormPage'
import LaporanViewerPage from '@/pages/laporan/LaporanViewerPage'
import PimpinanPage from '@/pages/pimpinan/PimpinanPage'
import ProgramKerjaPage from '@/pages/program/ProgramKerjaPage'
import SettingsPage from '@/pages/SettingsPage'
import StadionDashboardPage from '@/pages/stadion/StadionDashboardPage'
import RapatFormPage from '@/pages/rapat/RapatFormPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    // Restore auth state from PocketBase's persisted localStorage
    useAuthStore.getState().initialize()
    setReady(true)
  }, [])

  if (!ready) return null
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <>{children}</>
}

function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const role = useAuthStore((s) => s.role)
  if (role !== 'super_admin') return <Navigate to="/dashboard" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="stadion" element={<StadionDashboardPage />} />
        <Route
          path="kegiatan/new"
          element={
            <SuperAdminRoute>
              <KegiatanFormPage />
            </SuperAdminRoute>
          }
        />
        <Route path="kegiatan/:id" element={<KegiatanDetailPage />} />
        <Route
          path="kegiatan/:id/edit"
          element={
            <SuperAdminRoute>
              <KegiatanFormPage />
            </SuperAdminRoute>
          }
        />
        <Route path="kegiatan/:id/peserta/new" element={<PesertaFormPage />} />
        <Route path="kegiatan/:id/presensi" element={<PresensiPage />} />
        <Route path="kegiatan/:id/peserta/:pesertaId" element={<PesertaDetailPage />} />
        <Route path="kegiatan/:id/rapat/new" element={<RapatFormPage />} />
        <Route path="kegiatan/:id/rapat/:rapatId" element={<RapatFormPage />} />
        <Route path="laporan" element={<LaporanListPage />} />
        <Route path="laporan/new" element={<LaporanFormPage />} />
        <Route path="laporan/:id" element={<LaporanFormPage />} />
        <Route path="laporan/viewer/:id" element={<LaporanViewerPage />} />
        <Route
          path="pimpinan"
          element={
            <SuperAdminRoute>
              <PimpinanPage />
            </SuperAdminRoute>
          }
        />
        <Route path="program-kerja" element={<ProgramKerjaPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  )
}
